import React from 'react';
import { useSelector } from 'react-redux';

/**
 * Use Group Id Hook
 */
export default (name: string, data: Array<any>) => {
  const id = React.useMemo(() => {
    const next = data.find((item) => (
      item.name.toLowerCase() === name.toLowerCase()
    ));
    return next ? next.id : -1;
  }, [data]);

  return id;
};
